import Falcon from './falcon';
import FalconStore from './falcon/store';
import Stellarus from './stellarus';
import StellarisStore from './stellarus/store';
import Serenith from './serenith';
import SerenithStore from './serenith/store';
import Narukami from './narukami';
import NarukamiStore from './narukami/store';
import Welkin from './welkin';
import WelkinStore from './welkin/store';
import Inferno from './inferno';
import InfernoStore from './inferno/store';
import Tricera from './tricera';
import TriceraStore from './tricera/store';
import Luminae from './luminae';
import LuminaeStore from './luminae/store';
import Panther from './panther';
import PantherStore from './panther/store';

export const MECHA_INFO = {
  falcon: {
    name: '矛隼特装机',
    component: Falcon,
    store: FalconStore
  },
  stellarus: {
    name: '飞景特装机',
    component: Stellarus,
    store: StellarisStore
  },
  serenith: {
    name: '白虹特装机',
    component: Serenith,
    store: SerenithStore
  },
  narukami: {
    name: '鸣神特装机',
    component: Narukami,
    store: NarukamiStore
  },
  welkin: {
    name: '赤霄特装机',
    component: Welkin,
    store: WelkinStore
  },
  inferno: {
    name: '地狱火特装机',
    component: Inferno,
    store: InfernoStore
  },
  tricera: {
    name: '三角龙特装机',
    component: Tricera,
    store: TriceraStore
  },
  luminae: {
    name: '卢米纳尔特装机',
    component: Luminae,
    store: LuminaeStore
  },
  panther: {
    name: '黑豹特装机',
    component: Panther,
    store: PantherStore
  }
};
